import React, { useState } from 'react';
import WizardStages from '../shared/Wizard/WizardStages';
import ProjectsSelection from '../shared/ProjectsSelection/ProjectsSelection';
import ModelSelection from '../shared/ModelSelection/ModelSelection';
import TargetSelection from '../shared/TargetSelection/TargetSelection';
import TestConfiguration from '../shared/TestConfiguration/TestConfiguration';
import WizardSummary from '../shared/WizardSummary/WizardSummary';
import { useDispatch } from 'react-redux';
import { setTestConfigFieldValues } from '../../store/actions/jobConfiguration/jobConfiguration';


const JobConfiguration = () => {

  const dispatch = useDispatch();

  const [activeStage, setActiveStage] = useState(1);
  const [nextDisabled, setNextDisabled] = useState(true);

  //Project selection step state
  const [selectedProject, setSelectedProject] = useState(null);
  const [selectedSubProject, setSelectedSubProject] = useState(null);
  const [filters, setFilters] = useState({});

  const [testFieldsValues, setTestFieldsValues] = useState({});

  const onNext = () => {
    if (nextDisabled) {
      return;
    }
    if (activeStage== 4) {
      dispatch(setTestConfigFieldValues(testFieldsValues));
    }
    setActiveStage(activeStage+1);
  };
  const onBack = () => {
    if (activeStage== 4) {
      dispatch(setTestConfigFieldValues(testFieldsValues));
    }
    setActiveStage(activeStage-1);
  };

  const onExecJob = () => {};
  const onExportSetting = () => {};
  const onDownloadJson = () => {};

  const getStageContent = () => {
    switch (activeStage) {
      case 1:
        return (
          <ProjectsSelection 
            setNextDisabled={setNextDisabled}
            selectedProject={selectedProject}
            setSelectedProject={setSelectedProject}
            selectedSubProject={selectedSubProject}
            setSelectedSubProject={setSelectedSubProject}
          />
        );
      case 2:
        return (
          <ModelSelection
            selectedSubProject={selectedSubProject}
            setNextDisabled={setNextDisabled}
            filters={filters}
            setFilters={setFilters}
          />
        );
      case 3:
        return (
          <TargetSelection 
            subProject={selectedSubProject}
            setNextDisabled={setNextDisabled}
            filters={filters}
          />
        );
      case 4:
        return (
          <TestConfiguration 
            subProject={selectedSubProject}
            setNextDisabled={setNextDisabled}
            testFieldsValues={testFieldsValues}
            setTestFieldsValues={setTestFieldsValues}
          />
        );
      case 5:
        return (
          <WizardSummary
            onExecJob={onExecJob}
            onExportSetting={onExportSetting}
            onDownloadJson={onDownloadJson}
          />
        );
    }
  };

  return (
    <>
      <WizardStages
        activeStage={activeStage}
        getStageContent={getStageContent}
        onBack={onBack}
        onNext={onNext}
        isNextDisabled={nextDisabled}
        isNextDisplayed={activeStage != 5}
        // isBackDisabled={activeStage == 1}
        selectedSubProject={selectedSubProject?.projectName}
      />
    </>
  );
};

export default JobConfiguration;
